/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaAccountResponse from './AqaAccountResponse';

/**
 * The AqaQDEntryForAccounts model module.
 * @module model/AqaQDEntryForAccounts
 * @version v0
 */
export default class AqaQDEntryForAccounts {
  /**
   * Constructs a new <code>AqaQDEntryForAccounts</code>.
   * @alias module:model/AqaQDEntryForAccounts
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQDEntryForAccounts</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQDEntryForAccounts} obj Optional instance to populate.
   * @return {module:model/AqaQDEntryForAccounts} The populated <code>AqaQDEntryForAccounts</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQDEntryForAccounts();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'Number');
      if (data.hasOwnProperty('publishTimestamp'))
        obj.publishTimestamp = ApiClient.convertToType(data['publishTimestamp'], 'Number');
      if (data.hasOwnProperty('scope'))
        obj.scope = ApiClient.convertToType(data['scope'], 'String');
      if (data.hasOwnProperty('accounts'))
        obj.accounts = ApiClient.convertToType(data['accounts'], [AqaAccountResponse]);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaQDEntryForAccounts.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaQDEntryForAccounts.prototype.message = undefined;

/**
 * @member {String} title
 */
AqaQDEntryForAccounts.prototype.title = undefined;

/**
 * @member {String} description
 */
AqaQDEntryForAccounts.prototype.description = undefined;

/**
 * @member {Number} version
 */
AqaQDEntryForAccounts.prototype.version = undefined;

/**
 * @member {Number} publishTimestamp
 */
AqaQDEntryForAccounts.prototype.publishTimestamp = undefined;

/**
 * Allowed values for the <code>scope</code> property.
 * @enum {String}
 * @readonly
 */
AqaQDEntryForAccounts.ScopeEnum = {
  /**
   * value: "PRIVATE"
   * @const
   */
  PRIVATE: "PRIVATE",

  /**
   * value: "PROTECTED"
   * @const
   */
  PROTECTED: "PROTECTED",

  /**
   * value: "PUBLIC"
   * @const
   */
  PUBLIC: "PUBLIC"
};
/**
 * @member {module:model/AqaQDEntryForAccounts.ScopeEnum} scope
 */
AqaQDEntryForAccounts.prototype.scope = undefined;

/**
 * @member {Array.<module:model/AqaAccountResponse>} accounts
 */
AqaQDEntryForAccounts.prototype.accounts = undefined;

/**
 * @member {Boolean} successful
 */
AqaQDEntryForAccounts.prototype.successful = undefined;

